Clientmedications.$inject = [
    'allevaApi',
    '$scope',
    'dayjs'];

export default function Clientmedications(allevaApi, $scope, dayjs) {
    const ctrl = this;
    ctrl.medicationList = [];
    ctrl.inactiveMedicationList = [];

    ctrl.$onInit = function () {
        ctrl.loadMedications();
    };

    ctrl.loadMedications = function () {
        return new Promise((resolve, reject) => {

            if (ctrl.leadId) {
                allevaApi.ClientMedications.get(ctrl.leadId, null).then(function (response) {
                    var medicationList = [], inactiveMedicationList = [];
                    angular.forEach(response, function (value) {
                        if (value.discontinued) {
                            inactiveMedicationList.push(value);
                        }
                        else {
                            medicationList.push(value);
                        }
                    });
                    ctrl.medicationList = medicationList;
                    ctrl.inactiveMedicationList = inactiveMedicationList;
                    resolve();
                });
            }
            else {
                resolve();
            }
        });
    }

    ctrl.getJsonData = function () {
        const JSONData = {
            activeMeds: ctrl.medicationList,
            discontinuedMeds: ctrl.inactiveMedicationList
        };

        return JSON.stringify(JSONData);
    }

    ctrl.setData = function (JSONData) {
        const data = JSON.parse(JSONData);
        ctrl.medicationList = data.activeMeds;
        ctrl.inactiveMedicationList = data.discontinuedMeds;
        $scope.$apply();
    }

    ctrl.getPrintHtml = function () {
        let html = "<div class='med-title-section'><div class='row'>" +
            "<div class='col-xs-6'><div class='med-title'>Medications</div></div>" +
            "<div class='col-xs-6 med-time'><div ng-if='$ctrl.medicationTime'>as of " + ctrl.medicationTime + " &nbsp; </div></div></div></div> ";
    
        html += "<b><u>All Active Meds</u></b><div class='med-grid'>";
        angular.forEach(ctrl.medicationList, function (item) {
            html += "<div class='med-item'><b>Medication:</b> " + item.dispensableName + (item.prn == 1 ? " (PRN)" : "") +
                (item.instructions == "" ? "" : "<br><b>Instruction/Dosage:</b> " + item.instructions) + "</div>";
        });
        html += "</div>";
    
        if (ctrl.medicationList.length == 0) {
            html += "<p>No active medication found</p>";
        }
    
        if (ctrl.showDiscontinued) {
            html += "<br><b><u>Discontinued Meds</u></b><div class='med-grid'>";
            angular.forEach(ctrl.inactiveMedicationList, function (item) {
                html += "<div class='med-item'><b>Medication:</b> " + item.dispensableName + (item.prn == 1 ? " (PRN)" : "") +
                    (item.instructions == "" ? "" : "<br><b>Instruction/Dosage:</b> " + item.instructions) +
                    (item.stopDate == null ? "" : "<br><b>Discontinued Date:</b> " + dayjs(item.stopDate).format("MM/DD/YYYY")) + "</div>";
            });
            html += "</div>";
            if (ctrl.inactiveMedicationList.length == 0) {
                html += "<p>No discontinued medication found</p>";
            }
        }
    
        html += "<br>";
        return html;
    }

}
